import { createSlice } from '@reduxjs/toolkit';

const personalityArchetypesSlice = createSlice({
    name: 'personalityArchetypes',
    initialState: {
        list: {
            data: [],
            loading: false,
            error: null,
            page: 1,
            limit: 10,
            total: 0,
            totalPages: 1
        },
        createArchetype: { loading: false, error: null },
        updateArchetype: { loading: false, error: null }
    },
    reducers: {
        fetchPersonalityArchetypesStart: (state, action) => {
            state.list.loading = true;
            state.list.error = null;
            if (action.payload?.page === 1) {
                state.list.data = [];
            }
        },
        fetchPersonalityArchetypesSuccess: (state, action) => {
            state.list = { ...action.payload, loading: false };
        },
        fetchPersonalityArchetypesFail: (state, action) => {
            state.list.loading = false;
            state.list.error = action.payload;
        },

        createPersonalityArchetypeStart: (state) => {
            state.createArchetype.loading = true;
            state.createArchetype.error = null;
        },
        createPersonalityArchetypeSuccess: (state) => {
            state.createArchetype.loading = false;
        },
        createPersonalityArchetypeFail: (state, action) => {
            state.createArchetype.loading = false;
            state.createArchetype.error = action.payload;
        },

        updatePersonalityArchetypeStart: (state) => {
            state.updateArchetype.loading = true;
            state.updateArchetype.error = null;
        },
        updatePersonalityArchetypeSuccess: (state) => {
            state.updateArchetype.loading = false;
        },
        updatePersonalityArchetypeFail: (state, action) => {
            state.updateArchetype.loading = false;
            state.updateArchetype.error = action.payload;
        }
    }
});

export const {
    fetchPersonalityArchetypesStart,
    fetchPersonalityArchetypesSuccess,
    fetchPersonalityArchetypesFail,
    createPersonalityArchetypeStart,
    createPersonalityArchetypeSuccess,
    createPersonalityArchetypeFail,
    updatePersonalityArchetypeStart,
    updatePersonalityArchetypeSuccess,
    updatePersonalityArchetypeFail
} = personalityArchetypesSlice.actions;

export default personalityArchetypesSlice.reducer;
